import {useState, useEffect} from 'react'
import Api from '../../../../../thesis-and-dissertations/helpers/api'
import PaginationLayout from 'app/modules/admin/PANA/Assessment/PaginationLayout'
import {useNavigate} from 'react-router-dom'
import InformationLayout from './InformationLayout'
import usePagination from 'utils/hooks/usePagination'
import {clearLocalStorageExcept, timestampsFormat} from 'thesis-and-dissertations/helpers/helper'
import {toast} from 'react-toastify'
import 'app/modules/admin/PANA/Assessment/style.css'
import {PageTitle} from '_metronic/layout/core'
import {Badge} from 'react-bootstrap'

const api = new Api()

const AlumniSubmissionsPage = () => {
  let navigate = useNavigate()
  const [pagination, setPagination] = useState({
    per_page: 10,
    page: 1,
    total_page: 1,
    total_page_arr: [1, 2, 3, 4, 5],
    total_row: 10,
  })

  const [loading, setLoading] = useState(false)
  const [query, setQuery] = useState<any>({q: '', sort_order: 'desc'})

  const [data, setData] = useState<any>({})

  const [sorting, setSorting] = useState({
    sort_field: '',
    sort_order: '', // 'asc' atau 'desc'
  })

  const paginator: any = usePagination({
    totalCount: data?.total || 0,
    pageSize: pagination.per_page || 10,
    currentPage: pagination.page || 1,
  })

  useEffect(() => {
    setQuery({
      ...query,
      sort_field: sorting.sort_field,
      sort_order: sorting.sort_order,
    })
  }, [sorting])

  useEffect(() => {
    fetchData()
  }, [query, pagination.per_page, pagination.page])

  const onChangePerPage = (data: any) => {
    setPagination(data)
  }

  const fetchData = () => {
    setLoading(true)
    api
      .getMyAlumniSubmissions({
        ...query,
        page: pagination.page,
        per_page: pagination.per_page,
      })
      .then((response: any) => {
        const {data} = response.data

        let dataAlumni = {...data?.pagination, data: data?.submissions}
        setData(dataAlumni)
        setLoading(false)
      })
      .catch((error: any) => {
        setLoading(false)
        const {data, status} = error?.response
        toast.error(data?.message ?? data?.meta?.message)

        if (status == 401) {
          clearLocalStorageExcept()
          window.location.reload()
        }
      })
  }

  const getBadge = (status: string) => {
    if (status == 'Disetujui')
      return (
        <Badge bg='success' pill>
          Disetujui
        </Badge>
      )

    if (status == 'Menunggu Review')
      return (
        <Badge bg='warning' text='white' pill>
          Menunggu Review
        </Badge>
      )

    return (
      <Badge bg='danger' pill>
        Ditolak
      </Badge>
    )
  }

  return (
    <div>
      <InformationLayout />

      <div className='px-1 mt-4'>
        <h5 style={{fontSize: '17.6px', fontWeight: '600'}} className='text-black mt-8'>
          RIWAYAT PENGAJUAN ALUMNI
        </h5>
        <div className='table-responsive mt-10'>
          <table className='table table-borderless align-middle table-hover'>
            <thead style={{background: '#F3F4F6'}}>
              <tr>
                <td className='fw-bold'>Nama Alumni</td>
                <td className='fw-bold'>Program</td>
                <td className='fw-bold'>Universitas</td>
                <td className='fw-bold'>Tanggal Pengajuan</td>
                <td className='fw-bold'>Status</td>
              </tr>
            </thead>
            <tbody>
              {data?.data?.length > 0 ? (
                data?.data.map((item: any, index: any) => (
                  <tr key={item.id} className='bg-white'>
                    <td>
                      <div className='d-flex align-items-center'>
                        <img
                          src={item?.foto_profil}
                          alt={item?.nama_lengkap}
                          style={{width: '40px', height: '40px'}}
                          className='rounded-circle'
                        />
                        <div className='ms-3'>
                          <div className='fw-semibold'>{item?.nama_alumni}</div>
                          <div className='text-muted' style={{fontSize: '0.85rem'}}>
                            {item?.gelar_akademik}
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>{item?.program}</td>
                    <td>
                      <div className='d-flex align-items-center'>
                        <div>
                          <div className='fw-semibold'>-</div>
                          <div className='text-muted' style={{fontSize: '0.85rem'}}>
                            {item?.universitas}
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>{item?.tanggal_pengajuan}</td>
                    <td>
                      <div className='d-flex align-items-center'>{getBadge(item?.status)}</div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={5} className='text-center py-5'>
                    <div className='text-muted'>
                      <i className='fa fa-folder-open fa-2x mb-2'></i>
                      <div>Tidak ada data</div>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      <div className='px-1'>
        <PaginationLayout
          paginate={pagination}
          paginator={paginator}
          onChangePerPage={onChangePerPage}
          totalData={data?.data?.length}
        />
      </div>
    </div>
  )
}

const AlumniSubmissions = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            title: 'Dashboard',
            path: '/talenta-dashboard',
            isSeparator: false,
            isActive: false,
          },
          {
            title: '/',
            path: '',
            isSeparator: false,
            isActive: false,
          },
        ]}
      >
        Pengajuan Alumni
      </PageTitle>
      <AlumniSubmissionsPage />
    </>
  )
}

export default AlumniSubmissions
